import { defineStore } from 'pinia'
import { articles, tags } from '#nuxt-prepare'

export const useStore = defineStore('blog-lyber-store', {
  state: () => {
    return {
      articles: articles || [],
      tags: tags || [],
    }
  },
  getters: {
    articleBySlug: (state) => {
      return (slug) => state.articles?.find(a => a.slug === slug)
    }
  }
})